import { useEffect } from 'react';

import { useOidc } from '../providers';

export interface OidcLoginRedirectProps {
  element?: React.ReactNode;
}

export const OidcLoginRedirect = ({ element = null }: OidcLoginRedirectProps) => {
  const { login, logout, isAuthenticated, isLoading } = useOidc();
  useEffect(() => {
    if (isLoading) {
      return;
    }

    if (isAuthenticated) {
      logout();
    } else {
      login();
    }
  }, [isAuthenticated, login, logout, isLoading]);
  return element;
};
